var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelliJidea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.7898,
    y1: 40.0893,
    x2: 33.3172,
    y2: 40.0893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    style: {
      stopColor: "#F97A12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4591,
    style: {
      stopColor: "#B07B58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7241,
    style: {
      stopColor: "#577BAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9105,
    style: {
      stopColor: "#1E7CE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#087CFA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "17.7,54.6 0.8,41.2 9.2,25.6 33.3,35  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.7674,
    y1: 24.88,
    x2: 79.424,
    y2: 54.57
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F97A12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07179946,
    style: {
      stopColor: "#CB7A3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1541,
    style: {
      stopColor: "#9E7B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    style: {
      stopColor: "#757B91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    style: {
      stopColor: "#537BB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4324,
    style: {
      stopColor: "#387CCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5381,
    style: {
      stopColor: "#237CE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    style: {
      stopColor: "#147CEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7925,
    style: {
      stopColor: "#0B7CF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#087CFA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    points: "70,18.7 68.7,59.2 41.8,70 25.6,59.6 49.3,35 38.9,12.3 48.2,1.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.2277,
    y1: 42.9153,
    x2: 48.2903,
    y2: -1.7191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE315D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07840246,
    style: {
      stopColor: "#CB417E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1601,
    style: {
      stopColor: "#9E4E9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2474,
    style: {
      stopColor: "#755BB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3392,
    style: {
      stopColor: "#5365CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4365,
    style: {
      stopColor: "#386DDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5414,
    style: {
      stopColor: "#2374E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6576,
    style: {
      stopColor: "#1478F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#0B7BF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#087CFA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    points: "70,18.7 48.7,43.9 38.9,12.3 48.2,1.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.7204,
    y1: 16.473,
    x2: 55.5237,
    y2: 90.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE315D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04023279,
    style: {
      stopColor: "#F63462"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1037,
    style: {
      stopColor: "#DF3A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1667,
    style: {
      stopColor: "#C24383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    style: {
      stopColor: "#AD4A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5498,
    style: {
      stopColor: "#755BB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9175,
    style: {
      stopColor: "#1D76ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#087CFA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    points: "33.7,58.1 5.6,68.3 10.1,52.5 16,33.1 0,27.7 10.1,0 32.1,2.7 53.7,27.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 13.5,
    style: {
      fill: "#000000"
    },
    width: 43.2,
    height: 43.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 48.6,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.2,
    height: 2.7
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "29.4,22.4 29.4,19.1 20.4,19.1 20.4,22.4 23,22.4 23,33.7 20.4,33.7 20.4,37 29.4,37  29.4,33.7 26.9,33.7 26.9,22.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M38,37.3c-1.4,0-2.6-0.3-3.5-0.8c-0.9-0.5-1.7-1.2-2.3-1.9l2.5-2.8c0.5,0.6,1,1,1.5,1.3 c0.5,0.3,1.1,0.5,1.7,0.5c0.7,0,1.3-0.2,1.8-0.7c0.4-0.5,0.6-1.2,0.6-2.3V19.1h4v11.7c0,1.1-0.1,2-0.4,2.8c-0.3,0.8-0.7,1.4-1.3,2 c-0.5,0.5-1.2,1-2,1.2C39.8,37.1,39,37.3,38,37.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelliJidea);
export default __webpack_public_path__ + "static/media/IntelliJIDEA.1faf050ae894674aaa66ff1679da1171.svg";
export { ForwardRef as ReactComponent };